import { Component } from '@angular/core';
import { IBreadcrumbItem } from 'src/app/interfaces/breadcrumb/breadcrumb.interface';

@Component({
    selector: 'app-rss-validator',
    templateUrl: './rss-validator.component.html',
    styleUrls: ['./rss-validator.component.scss'],
})
export class RssValidatorComponent {
    breadcrumb: IBreadcrumbItem[] = [
        {
            link: '',
            title: 'Rss validator',
        },
    ];
}
